import type { Settings } from '@ant-design/react-slick';
import { CTA } from '@volkswagen-onehub/components-core';
import { ArrowLeft, ArrowRight } from '@volkswagen-onehub/icons-core';

import Slider from '@ant-design/react-slick';
import { type ReactNode } from 'react';
import { NAVIGATION_HEIGHT } from '@/modules/constants/navigation';
import type { BreakpointsProps } from '@/types';
import {
  StyledSliderArrow,
  StyledSliderWrapper,
} from './GalleryViewerCarousel.styles';

export interface GalleryViewerCarouselProps
  extends Settings,
    BreakpointsProps<Pick<GalleryViewerCarouselProps, 'width' | 'height'>> {
  offsetTop?: number;
  children: ReactNode[];
  width?: string;
  height?: string;
  arrows?: boolean;
  customPagingLabels?: ReactNode[];
}

const GalleryViewerCarousel = ({
  dots = true,
  customPagingLabels = [],
  prevArrow,
  nextArrow,
  arrows = true,
  offsetTop = NAVIGATION_HEIGHT,
  width,
  height,
  ...restProps
}: GalleryViewerCarouselProps) => {
  return (
    <StyledSliderWrapper offsetTop={offsetTop} width={width} height={height}>
      <Slider
        useTransform={false}
        dots={dots}
        customPaging={(i: number) => {
          return (
            <CTA tag="button" emphasis="tertiary">
              {customPagingLabels[i] || `Slide ${i}`}
            </CTA>
          );
        }}
        prevArrow={
          <StyledSliderArrow>
            {!prevArrow ? (
              <CTA tag="button" icon={<ArrowLeft />} emphasis="secondary" />
            ) : (
              prevArrow
            )}
          </StyledSliderArrow>
        }
        nextArrow={
          <StyledSliderArrow>
            {!nextArrow ? (
              <CTA tag="button" icon={<ArrowRight />} emphasis="secondary" />
            ) : (
              nextArrow
            )}
          </StyledSliderArrow>
        }
        arrows={arrows}
        {...restProps}
      />
    </StyledSliderWrapper>
  );
};

export default GalleryViewerCarousel;
